/**
 * Меню-каталог PlayVinyl.
 * <pv-catalog> — десктопна шапка й панель (snippets/pv-catalog.liquid).
 * <pv-catalog-mobile> — акордеон у мобільному меню (snippets/pv-catalog-mobile.liquid).
 * Стилі — assets/pv-catalog.css.
 */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function readHints(el) {
    try {
      const list = JSON.parse(el.dataset.hints || '[]');
      return Array.isArray(list) ? list.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  /* Поле пошуку саме набирає підказки й ховає їх, щойно людина пише. */
  function initSearchHints(form, hints) {
    const input = form.querySelector('[data-pvc-input]');
    const ph = form.querySelector('[data-pvc-ph]');
    if (!input || !ph) return;
    const sync = () => form.classList.toggle('has-value', input.value.length > 0 || document.activeElement === input);
    input.addEventListener('input', sync);
    input.addEventListener('focus', sync);
    input.addEventListener('blur', sync);
    sync();
    if (!hints.length || reduce.matches) return;

    let p = 0;
    let i = hints[0].length;
    let del = true;
    let timer = 0;
    const step = () => {
      const s = hints[p];
      ph.textContent = s.slice(0, i);
      let d = del ? 32 : 70;
      if (!del && i >= s.length) {
        d = 1800;
        del = true;
      } else if (del && i <= 0) {
        del = false;
        p = (p + 1) % hints.length;
        d = 350;
      }
      i += del ? -1 : 1;
      timer = window.setTimeout(step, d);
    };
    timer = window.setTimeout(step, 2200);
    form._pvcStop = () => window.clearTimeout(timer);
  }

  /* Живі підказки: товари й колекції з /search/suggest.json. */
  function initSuggest(form) {
    const input = form.querySelector('[data-pvc-input]');
    const box = form.querySelector('[data-pvc-suggest]');
    if (!input || !box) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const searchUrl = form.getAttribute('action') || '/search';
    let ctrl = null;
    let timer = 0;
    let focusIdx = -1;

    const money = (v) => {
      const n = Number(v);
      if (!isFinite(n)) return '';
      return n.toLocaleString('uk-UA', { maximumFractionDigits: 0 }).replace(/ /g, ' ') + ' ₴';
    };
    const close = () => {
      box.hidden = true;
      box.innerHTML = '';
      focusIdx = -1;
    };
    const render = (q, res) => {
      const products = (res.products || []).slice(0, 5);
      const cols = (res.collections || []).slice(0, 3);
      if (!products.length && !cols.length) {
        box.innerHTML = `<div class="pvc-suggest__group"><span class="pvc-eyebrow">Нічого не знайшли за «${esc(q)}»</span></div>`;
        box.hidden = false;
        return;
      }
      let html = '';
      if (cols.length) {
        html += '<div class="pvc-suggest__group"><span class="pvc-eyebrow">Розділи</span>' +
          cols.map((c) => `<a class="is-plain" href="${esc(c.url)}"><span>${esc(c.title)}</span><span class="pvc-cnt">→</span></a>`).join('') + '</div>';
      }
      if (products.length) {
        html += '<div class="pvc-suggest__group"><span class="pvc-eyebrow">Товари</span>' +
          products.map((p) => {
            const img = p.featured_image && p.featured_image.url ? `<img src="${esc(p.featured_image.url)}&width=96" alt="" loading="lazy">` : '<span></span>';
            return `<a href="${esc(p.url)}">${img}<span>${esc(p.title)}</span><span class="pvc-price">${money(p.price)}</span></a>`;
          }).join('') + '</div>';
      }
      html += `<a class="pvc-suggest__all" href="${esc(searchUrl)}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last">Усі результати за «${esc(q)}» →</a>`;
      box.innerHTML = html;
      box.hidden = false;
      focusIdx = -1;
    };
    const fetchSuggest = (q) => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`;
      fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((d) => {
          if (input.value.trim() !== q) return;
          render(q, (d && d.resources && d.resources.results) || {});
        })
        .catch(() => {});
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) {
        close();
        return;
      }
      timer = window.setTimeout(() => fetchSuggest(q), 180);
    });
    input.addEventListener('keydown', (e) => {
      const links = [...box.querySelectorAll('a')];
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (box.hidden || !links.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')) return;
      if (e.key === 'Enter') {
        if (focusIdx >= 0) {
          e.preventDefault();
          window.location.href = links[focusIdx].href;
        }
        return;
      }
      e.preventDefault();
      focusIdx = (focusIdx + (e.key === 'ArrowDown' ? 1 : links.length - 1) + (focusIdx < 0 && e.key === 'ArrowUp' ? 1 : 0)) % links.length;
      links.forEach((a, n) => a.classList.toggle('is-focus', n === focusIdx));
    });
    document.addEventListener('pointerdown', (e) => {
      if (!form.contains(e.target)) close();
    });
  }

  class PvCatalog extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.toggleBtn = this.querySelector('[data-pvc-toggle]');
      this.panel = this.querySelector('[data-pvc-panel]');
      this.index = this.querySelector('[data-pvc-index]');
      this.knob = this.querySelector('[data-pvc-knob]');
      this.rows = [...this.querySelectorAll('[data-pvc-row]')];
      this.panes = [...this.querySelectorAll('[data-pvc-pane]')];
      this.quick = this.querySelector('.pvc-quick');
      this.quickLinks = [...this.querySelectorAll('[data-pvc-quick]')];
      this.active = 0;
      this.closeTimer = 0;
      this.openTimer = 0;
      this.swapTimer = 0;

      const wrapper = this.closest('header-component');
      this.wrapper = wrapper;
      if (wrapper) wrapper.classList.add('pvc-on');

      this.toggleBtn.addEventListener('click', () => this.toggle());
      this.querySelector('[data-pvc-underlay]').addEventListener('click', () => this.close());

      this.rows.forEach((row) => {
        const i = Number(row.dataset.pvcRow);
        row.addEventListener('mouseenter', () => {
          if (hover.matches) this.activate(i);
        });
        row.addEventListener('focus', () => this.activate(i));
        row.addEventListener('click', (e) => {
          if (!hover.matches && this.active !== i) {
            e.preventDefault();
            this.activate(i);
          }
        });
      });

      this.index.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        const n = this.rows.length;
        const next = (this.active + (e.key === 'ArrowDown' ? 1 : n - 1)) % n;
        this.rows[next].focus();
      });

      this.quickLinks.forEach((a) => {
        const i = Number(a.dataset.pvcQuick);
        a.addEventListener('mouseenter', () => {
          if (!hover.matches) return;
          window.clearTimeout(this.closeTimer);
          window.clearTimeout(this.openTimer);
          this.openTimer = window.setTimeout(() => {
            this.activate(i);
            this.open();
          }, this.isOpen() ? 0 : 140);
        });
        a.addEventListener('mouseleave', () => window.clearTimeout(this.openTimer));
        a.addEventListener('click', (e) => {
          if (!hover.matches && !(this.isOpen() && this.active === i)) {
            e.preventDefault();
            this.activate(i);
            this.open();
          }
        });
      });

      /* Наведення: панель закривається, коли курсор пішов на сторінку (притемнений шар) або з вікна. */
      this.underlay = this.querySelector('[data-pvc-underlay]');
      this.addEventListener('mouseover', (e) => {
        if (!hover.matches || !this.isOpen()) return;
        if (this.underlay.contains(e.target)) {
          window.clearTimeout(this.closeTimer);
          this.closeTimer = window.setTimeout(() => this.close(), 320);
        } else {
          window.clearTimeout(this.closeTimer);
        }
      });
      this.addEventListener('mouseleave', (e) => {
        if (!hover.matches || !this.isOpen()) return;
        if (e.relatedTarget && this.contains(e.relatedTarget)) return;
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => this.close(), 320);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
          this.toggleBtn.focus();
        }
      });
      document.addEventListener('theme:cart-drawer:show', () => this.close());
      window.addEventListener('resize', () => {
        this.moveKnob();
        this.moveUnderline();
      }, { passive: true });

      this.querySelectorAll('[data-pvc-search]').forEach((f) => {
        initSearchHints(f, readHints(this));
        initSuggest(f);
      });

      this.initGroove();

      const current = this.quickLinks.find((a) => a.getAttribute('aria-current') === 'page');
      if (current) this.activate(Number(current.dataset.pvcQuick), true);
      else this.activate(0, true);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.moveUnderline());
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    open() {
      if (this.isOpen()) return;
      const header = this.closest('.theme__header');
      const bottom = header ? header.getBoundingClientRect().bottom : this.getBoundingClientRect().bottom;
      this.style.setProperty('--pvc-top', `${Math.max(0, Math.round(bottom))}px`);
      this.classList.add('is-open');
      /* прозора шапка на головній стає синьою, поки відкрита панель — механізм теми */
      if (this.wrapper) this.wrapper.classList.add('meganav--visible');
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('pvc-open');
      window.requestAnimationFrame(() => this.moveKnob());
    }

    close() {
      if (!this.isOpen()) return;
      window.clearTimeout(this.openTimer);
      this.classList.remove('is-open');
      if (this.wrapper) this.wrapper.classList.remove('meganav--visible');
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('pvc-open');
      this.quickLinks.forEach((a) => a.classList.remove('is-active'));
      this.moveUnderline();
    }

    toggle() {
      if (this.isOpen()) this.close();
      else this.open();
    }

    activate(i, initial) {
      if (!this.rows[i]) return;
      const changed = i !== this.active || initial;
      this.active = i;
      this.rows.forEach((r, n) => r.classList.toggle('is-active', n === i));
      this.quickLinks.forEach((a) => a.classList.toggle('is-active', Number(a.dataset.pvcQuick) === i && !initial));
      this.moveKnob();
      this.moveUnderline();
      if (!changed) return;

      const show = () => {
        this.panes.forEach((p, n) => {
          const on = n === i;
          p.hidden = !on;
          p.classList.toggle('is-active', on);
          p.classList.remove('is-out');
        });
      };
      if (initial || reduce.matches || !this.isOpen()) {
        show();
        return;
      }
      const current = this.panes.find((p) => p.classList.contains('is-active'));
      if (current) current.classList.add('is-out');
      window.clearTimeout(this.swapTimer);
      this.swapTimer = window.setTimeout(show, 140);
    }

    moveKnob() {
      const r = this.rows[this.active];
      if (!r || !this.knob) return;
      this.knob.style.top = `${r.offsetTop}px`;
      this.knob.style.height = `${r.offsetHeight}px`;
      this.knob.style.width = `${r.offsetWidth}px`;
      this.knob.style.left = `${r.offsetLeft}px`;
    }

    /* «Голка» на доріжці стає під ссилку під курсором, активний розділ або кнопку «Каталог». */
    moveUnderline() {
      if (!this.groove || !this.quick) return;
      const barRect = this.bar.getBoundingClientRect();
      const a = this.hoverLink || this.quick.querySelector('a.is-active') || this.quick.querySelector('a[aria-current]');
      const el = a || (this.isOpen() ? this.toggleBtn : null);
      if (!el) {
        this.needleTarget = null;
        return;
      }
      const r = el.getBoundingClientRect();
      this.needleTarget = r.left + r.width / 2 - barRect.left;
    }

    initGroove() {
      this.bar = this.querySelector('.pvc-bar');
      this.groove = this.querySelector('[data-pvc-groove]');
      if (!this.groove || !this.bar) return;
      const path = this.groove.querySelector('path');
      const needle = this.groove.querySelector('circle');
      const logo = this.querySelector('[data-pvc-logo]');
      const search = this.querySelector('.pvc-bar .pvc-search');
      let geo = null;

      /* Лінія-тонарм: виходить праворуч від лого, плавно опускається під меню, іде рівно
         і піднімається в лівий край поля пошуку. Голка ходить рівною ділянкою. */
      const layout = () => {
        const bar = this.bar.getBoundingClientRect();
        if (!bar.width || !logo || !search) return;
        const w = bar.width;
        const h = bar.height;
        const l = logo.getBoundingClientRect();
        const sr = search.getBoundingClientRect();
        const x0 = l.right - bar.left + 14;
        const y0 = h / 2;
        const x1 = sr.left - bar.left;
        const y1 = sr.top - bar.top + sr.height / 2;
        const yb = h - 10;
        const r = Math.min(70, (x1 - x0) / 4);
        this.groove.setAttribute('viewBox', `0 0 ${w} ${h}`);
        path.setAttribute('d', `M${x0} ${y0} C${x0 + r * 0.55} ${y0} ${x0 + r * 0.45} ${yb} ${x0 + r} ${yb} L${x1 - r} ${yb} C${x1 - r * 0.45} ${yb} ${x1 - r * 0.55} ${y1} ${x1} ${y1}`);
        geo = { a: x0 + r, b: x1 - r, yb, len: path.getTotalLength() };
      };
      layout();
      window.addEventListener('resize', layout, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);

      this.quick && this.quick.querySelectorAll('a').forEach((a) => {
        a.addEventListener('mouseenter', () => { this.hoverLink = a; this.moveUnderline(); });
        a.addEventListener('mouseleave', () => { this.hoverLink = null; this.moveUnderline(); });
      });

      const place = (x, y) => {
        needle.setAttribute('cx', x.toFixed(1));
        needle.setAttribute('cy', y.toFixed(1));
      };
      if (reduce.matches) {
        if (geo) place(geo.a, geo.yb);
        return;
      }

      let nx = null;
      let last = 0;
      const loop = (t) => {
        if (geo && t - last > 30) {
          last = t;
          if (this.needleTarget == null) {
            /* без цілі голка повільно ходить уздовж рівної ділянки */
            const k = 0.5 - 0.5 * Math.cos(t * 0.00035);
            const target = geo.a + (geo.b - geo.a) * k;
            nx = nx == null ? target : nx + (target - nx) * 0.2;
          } else {
            const target = Math.max(geo.a, Math.min(geo.b, this.needleTarget));
            nx = nx == null ? target : nx + (target - nx) * 0.16;
          }
          place(nx, geo.yb);
        }
        this.raf = window.requestAnimationFrame(loop);
      };
      this.raf = window.requestAnimationFrame(loop);
    }
  }

  class PvCatalogMobile extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const menu = this.closest('mobile-menu');
      if (menu) menu.classList.add('pvm-on');
      this.querySelectorAll('[data-pvm-row]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.pvm-item');
          const open = item.classList.contains('is-open');
          this.querySelectorAll('.pvm-item.is-open').forEach((x) => {
            x.classList.remove('is-open');
            const b = x.querySelector('[data-pvm-row]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            window.setTimeout(() => btn.scrollIntoView({ block: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' }), 160);
          }
        });
      });
      this.querySelectorAll('[data-pvm-sub]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const sub = btn.closest('.pvm-sub');
          const open = sub.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', String(open));
        });
      });
      /* Мініатюри розділів беремо з десктопної панелі на тій самій сторінці (блоки шапки «Розділ каталогу»). */
      this.querySelectorAll('[data-pvm-thumb]').forEach((slot) => {
        const row = slot.closest('[data-pvm-index]');
        const src = row && document.querySelector(`.pvc-row[data-pvc-row="${row.dataset.pvmIndex}"] .pvc-thumb img`);
        if (src) slot.appendChild(src.cloneNode(true));
      });
      this.querySelectorAll('[data-pvc-search]').forEach((f) => initSearchHints(f, readHints(this)));
    }
  }

  /* Мобільна шапка: рівна тонка лінія по низу шапки від плашки «Каталог» до кошика, голка повільно ходить. */
  function initMobileGroove() {
    const svg = document.querySelector('[data-pvc-mgroove]');
    if (!svg) return;
    const bar = svg.parentElement;
    const path = svg.querySelector('path');
    const needle = svg.querySelector('circle');
    let geo = null;
    const layout = () => {
      const b = bar.getBoundingClientRect();
      let x0 = Infinity;
      let x1 = -Infinity;
      bar.querySelectorAll('.header__mobile__button, .header__logo').forEach((el) => {
        const r = el.getBoundingClientRect();
        if (!r.width) return;
        x0 = Math.min(x0, r.left - b.left);
        x1 = Math.max(x1, r.right - b.left);
      });
      if (!b.width || !isFinite(x0) || x1 - x0 < 80) { geo = null; path.setAttribute('d', ''); needle.setAttribute('cx', '-10'); return; }
      const h = b.height;
      const yb = h - 7;
      svg.setAttribute('viewBox', `0 0 ${b.width} ${h}`);
      path.setAttribute('d', `M${x0} ${yb} L${x1} ${yb}`);
      geo = { a: x0 + 18, b: x1 - 18, yb };
    };
    layout();
    window.addEventListener('resize', layout, { passive: true });
    window.addEventListener('load', layout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    const place = (x) => { needle.setAttribute('cx', x.toFixed(1)); needle.setAttribute('cy', String(geo.yb)); };
    if (reduce.matches) { if (geo) place(geo.a); return; }
    let last = 0;
    const loop = (t) => {
      if (geo && t - last > 40) {
        last = t;
        const k = 0.5 - 0.5 * Math.cos(t * 0.00025);
        place(geo.a + (geo.b - geo.a) * k);
      }
      window.requestAnimationFrame(loop);
    };
    window.requestAnimationFrame(loop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMobileGroove);
  else initMobileGroove();

  if (!customElements.get('pv-catalog')) customElements.define('pv-catalog', PvCatalog);
  if (!customElements.get('pv-catalog-mobile')) customElements.define('pv-catalog-mobile', PvCatalogMobile);
})();
